import axios from 'axios';
import backendURLs from '~/misc/backendURLs';

export default (contactPayload) => {
  return axios
    .post(backendURLs.contact, contactPayload)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
